import cn from '../../lib/cn';

/** Small pill label. Pass `className` to override colours (e.g. status styles). */
export default function Badge({ children, className }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border border-ink-200 bg-ink-50 px-2.5 py-1 text-xs font-semibold text-ink-700',
        className
      )}
    >
      {children}
    </span>
  );
}
